import Vue from "vue";
import Vuex from "vuex";
import store from "store";
import AntDesignDarkTheme from "@/components/kit-vendors/antd/themes/themeDark";
import AntDesignLightTheme from "@/components/kit-vendors/antd/themes/themeLight";

const APP_NAME = process.env.VUE_APP_APP_NAME || "Quy trình";

Vue.use(Vuex);

const STORED_SETTINGS = (storedSettings) => {
  const settings = {};
  Object.keys(storedSettings).forEach((key) => {
    const item = store.get(`app.settings.${key}`);
    settings[key] = typeof item !== "undefined" ? item : storedSettings[key];
  });
  return settings;
};

export default {
  state: {
    ...STORED_SETTINGS({
      logo: APP_NAME ,
      locale: "en-US",
      menuLayoutType: "nomenu",
      routerAnimation: "slide-fadein-up",
      menuColor: "white",
      theme: "light",
      authPagesColor: "white",
      primaryColor: "#4b7cf3",
      isTopbarFixed: true,
    }),
  },
  mutations: {
    CHANGE_SETTING(state, payload) {
      window.localStorage.setItem(
        `app.settings.${payload.setting}`,
        payload.value
      );
      state[payload.setting] = payload.value;
    },
    SETUP_URL_SETTINGS(state, payload) {
      let queryParams = payload;
      let keys = false;
      if (payload.redirect) {
        const str = payload.redirect;
        const subs = str.substring(str.indexOf("?") + 1);
        if (str.indexOf("?") >= 0) {
          queryParams = JSON.parse(
            '{"' +
              decodeURI(subs)
                .replace(/"/g, '\\"')
                .replace(/&/g, '","')
                .replace(/=/g, '":"') +
              '"}'
          );
        }
      }
      delete queryParams.redirect;
      keys = Object.keys(queryParams);
      if (keys.length) {
        keys.forEach((key) => {
          let value;
          switch (queryParams[key]) {
            case "false":
              value = false;
              break;
            case "true":
              value = true;
              break;
            default:
              value = queryParams[key];
              break;
          }
          if (key in state) {
            state[key] = value;
          }
        });
      }
    },
    SET_PRIMARY_COLOR(state, payload) {
      const { color } = payload;
      const addStyles = () => {
        const styleElement = document.querySelector("#primaryColor");
        if (styleElement) {
          styleElement.remove();
        }
        const body = document.querySelector("body");
        const styleEl = document.createElement("style");
        const css = document.createTextNode(
          `:root { --kit-color-primary: ${color};}`
        );
        styleEl.setAttribute("id", "primaryColor");
        styleEl.appendChild(css);
        body.appendChild(styleEl);
      };
      addStyles();
      state.primaryColor = color;
      store.set("app.settings.primaryColor", color);
    },
    SET_THEME(state, payload) {
      const { theme } = payload;
      if (theme === "light") {
        document.querySelector("body").classList.remove("kit__dark");
        window.less.modifyVars(AntDesignLightTheme);
        state.menuColor = "light";
        store.set("app.settings.menuColor", "light");
      }

      if (theme === "dark") {
        document.querySelector("body").classList.add("kit__dark");
        window.less.modifyVars(AntDesignDarkTheme);
        state.menuColor = "dark";
        store.set("app.settings.menuColor", "dark");
      }
      state.theme = theme;
      store.set("app.settings.theme", theme);
    },
  },
  actions: {},
  getters: {
    state: (state) => state,
  },
};
